import React from "react";
import WofButton from "../WofButton";
import { PromoUnitsType } from "../../types";
import "./styles.scss";

const PromoUnits: React.FC<PromoUnitsType> = ({ promos }) => {
  return (
    <div className="promo-all-units">
      {promos.map(
        (
          {
            image,
            title,
            description,
            ctaText,
            ctaUrl,
            type,
            ctabaseColor,
            ctahoverColor,
            fullCardLinkUrl,
          },
          i
        ) => (
          <div key={`promo-unit-${i}`} className="promo-single-unit">
            <img src={image} alt={title} />
            <div className="promo-top">
              <h2 className="promo-title">{title}</h2>
            </div>
            <div className="promo-bottom">
              <span dangerouslySetInnerHTML={{ __html: description }}/>
              {/** TOOD: WofLink */}
              {ctaUrl && ctaText ? (
                <WofButton
                  href={ctaUrl}
                  baseColor={ctabaseColor}
                  hoverColor={ctahoverColor}
                  vType="light"
                >
                  {ctaText}
                </WofButton>
              ) : null}
            </div>
            {fullCardLinkUrl ? (
              <a className={"all-cards-link"} href={fullCardLinkUrl}/>
            ) : null}
          </div>
        )
      )}
    </div>
  );
};

export default PromoUnits;
